import { render, staticRenderFns } from "./defaultView.vue?vue&type=template&id=10cfdb98&scoped=true"
import script from "./defaultView.vue?vue&type=script&lang=js"
export * from "./defaultView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cfdb98",
  null
  
)

export default component.exports